import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-payroll-runs',
  templateUrl: './payroll-runs.component.html',
  styleUrls: ['./payroll-runs.component.scss']
})
export class PayrollRunsComponent implements OnInit {

  runs: any[] = [];
  isLoading = false;
  newMonthYear = '';
  newNotes = '';

  constructor(
    private apiService: ApiService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadRuns();
  }

  loadRuns(): void {
    this.isLoading = true;
    this.apiService.getPayrollRuns().subscribe(
      data => {
        this.runs = (data && data.runs) ? data.runs : [];
        this.isLoading = false;
      },
      _ => {
        this.isLoading = false;
        this.snackBar.open('Failed to load payroll runs', 'Close', { duration: 3000 });
      }
    );
  }

  createRun(): void {
    if (!this.newMonthYear) {
      this.snackBar.open('Please enter month (YYYY-MM)', 'Close', { duration: 3000 });
      return;
    }
    this.isLoading = true;
    this.apiService.createPayrollRun(this.newMonthYear, this.newNotes).subscribe(
      _ => {
        this.snackBar.open('Payroll run created', 'Close', { duration: 3000 });
        this.newMonthYear = '';
        this.newNotes = '';
        this.loadRuns();
      },
      err => {
        this.isLoading = false;
        const msg = err?.error?.message || 'Failed to create payroll run';
        this.snackBar.open(msg, 'Close', { duration: 4000 });
      }
    );
  }

  viewRun(run: any): void {
    this.router.navigate(['/payroll-runs', run.runId]);
  }
}
